import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useApp } from "../../contexts/AppContext";

const ADMIN_NAV_ITEMS = [
  { path: "/dashboard", icon: "📊", label: "Dashboard" },
  { path:"/analytics", icon:"📈", label:"Analytics" },
  { path:"/request", icon:"📝", label:"New Request" },
  { path:"/requests", icon:"⏳", label:"Contract Requests" },
  { path:"/contracts", icon:"📋", label:"Contracts" },
  { path:"/suppliers", icon:"🏢", label:"Suppliers" },
  { path:"/files", icon:"📁", label:"File Explorer" },
  { path:"/templates", icon:"📄", label:"Templates" },
];

const USER_NAV_ITEMS = [
  { path:"/request", icon:"📝", label:"New Request" },
  { path:"/requests", icon:"⏳", label:"Contract Requests" },
  { path:"/contracts", icon:"📋", label:"My Requests" },
];
const ADMIN_ITEMS = [
  { path:"/admin", icon:"⚙️", label:"Admin Panel" },
  { path:"/admin/signatures", icon:"🖊️", label:"My Signatures" },
  { path:"/admin/executions", icon:"✍️", label:"Contract Executions" },
  { path:"/admin/expiry", icon:"⏰", label:"Expiry Management" },
  { path:"/admin/expiry-settings", icon:"⚡", label:"Expiry Settings" },
  { path:"/admin/users", icon:"👥", label:"User Management" },
  { path:"/admin/bulk-import", icon:"📥", label:"Bulk Import" },
];

export const Sidebar = ({ collapsed, onToggle }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAdmin, isUser, currentUser } = useApp();
  const NAV_ITEMS = isUser ? USER_NAV_ITEMS : ADMIN_NAV_ITEMS;

  return (
    <div className={`${collapsed ? "w-16" : "w-60"} bg-slate-800 border-r border-slate-700 flex flex-col transition-all duration-250 overflow-hidden relative z-10`}>
      {/* Logo */}
      <div
        onClick={onToggle}
        className={`${collapsed ? "px-0 py-4" : "px-5 py-5 pb-4"} border-b border-slate-700 flex items-center gap-3 cursor-pointer ${collapsed ? "justify-center" : "justify-start"}`}
      >
        <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-yellow-600/20 to-yellow-600/35 border border-yellow-600/25 flex items-center justify-center text-lg shrink-0">
          {String.fromCodePoint(0x2696)}
        </div>
        {!collapsed && (
          <div>
            <div className="font-serif text-lg font-semibold text-slate-100 leading-tight">LexCore</div>
            <div className="text-xs text-yellow-600 tracking-widest uppercase">CMS</div>
          </div>
        )}
      </div>

      {/* Navigation */}
      <nav className="flex-1 px-2 py-3 overflow-y-auto">
        {!collapsed && <div className="text-xs text-slate-600 uppercase tracking-widest font-semibold px-2 py-2 pb-1">MAIN</div>}
        {NAV_ITEMS.map(item => {
          const active = location.pathname === item.path || (item.path !== "/" && location.pathname.startsWith(item.path));
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              title={collapsed ? item.label : undefined}
              className={`w-full flex items-center gap-2.5 transition-all duration-150 mb-0.5 rounded-lg text-sm ${
                collapsed ? "justify-center px-0 py-2.5" : "justify-start px-3 py-2.5"
              } ${
                active
                  ? "bg-gradient-to-r from-yellow-600/15 to-transparent border border-yellow-600/20 text-yellow-600 font-semibold"
                  : "bg-transparent border border-transparent text-slate-400 font-normal hover:text-slate-300"
              }`}
            >
              <span className="text-base shrink-0">{item.icon}</span>
              {!collapsed && <span>{item.label}</span>}
              {active && !collapsed && <div className="w-1 h-1 rounded-full bg-yellow-600 ml-auto" />}
            </button>
          );
        })}

        {isAdmin && (
          <>
            {!collapsed && <div className="text-xs text-slate-600 uppercase tracking-widest font-semibold px-2 py-2 mt-4 pb-1">ADMIN</div>}
            {ADMIN_ITEMS.map(item => {
              const active = location.pathname === item.path;
              return (
                <button
                  key={item.path}
                  onClick={() => navigate(item.path)}
                  title={collapsed ? item.label : undefined}
                  className={`w-full flex items-center gap-2.5 transition-all duration-150 mb-0.5 rounded-lg text-sm ${
                    collapsed ? "justify-center px-0 py-2.5" : "justify-start px-3 py-2.5"
                  } ${
                    active
                      ? "bg-gradient-to-r from-yellow-600/15 to-transparent border border-yellow-600/20 text-yellow-600 font-semibold"
                      : "bg-transparent border border-transparent text-slate-400 font-normal hover:text-slate-300"
                  }`}
                >
                  <span className="text-base shrink-0">{item.icon}</span>
                  {!collapsed && <span>{item.label}</span>}
                </button>
              );
            })}
          </>
        )}
      </nav>

      {/* User */}
      {currentUser && (
        <div className={`${collapsed ? "px-0 py-3" : "px-4 py-3"} border-t border-slate-700 flex items-center gap-2.5 ${collapsed ? "justify-center" : "justify-start"}`}>
          <div className="w-8 h-8 rounded-full bg-gradient-to-br from-yellow-600 to-yellow-800 flex items-center justify-center text-slate-900 font-bold text-sm shrink-0">
            {currentUser.displayName?.[0] || "U"}
          </div>
          {!collapsed && (
            <div className="overflow-hidden">
              <div className="text-sm text-slate-100 font-medium whitespace-nowrap overflow-hidden text-ellipsis">
                {currentUser.displayName}
              </div>
              <div className="text-sm text-slate-400">{currentUser.jobTitle || "User"}</div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
